import PlayerPauseFilled from './src/player-pause-filled';
export default PlayerPauseFilled;